import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Shield, Loader2 } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const fmt = (iso) => (iso ? iso.split("-").reverse().join("/") : "—");

export default function DemoRegister() {
  const { codice } = useParams();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [step, setStep] = useState("email");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [challenge, setChallenge] = useState("");
  const [busy, setBusy] = useState(false);
  const [finalPwd, setFinalPwd] = useState("");

  useEffect(() => {
    api.get(`/demo/${codice}`).then(({ data }) => setInfo(data)).catch((e) => { setErr(formatApiError(e.response?.data?.detail)); setStep("invalid"); });
  }, [codice]);

  const call = async (fn) => {
    setBusy(true); setErr("");
    try { await fn(); } catch (e) { setErr(formatApiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  const register = (e) => { e.preventDefault(); call(async () => {
    const { data } = await api.post(`/demo/${codice}/register`, { email, name });
    setChallenge(data.challenge_id); setStep("otp");
  }); };
  const verify = (e) => { e.preventDefault(); call(async () => {
    const { data } = await api.post(`/demo/${codice}/verify`, { challenge_id: challenge, code });
    setFinalPwd(data.password || "");
    setStep("done");
  }); };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 pgp-grid-bg" data-testid="demo-register-page">
      <div className="w-full max-w-sm pgp-fade-up">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-10 w-10 rounded-xl bg-amber-500 flex items-center justify-center"><Shield className="h-5 w-5 text-[#0a0d14]" strokeWidth={2.4} /></div>
          <span className="font-head font-extrabold text-lg">Patro<span className="text-amber-500">Gest</span>Pro</span>
        </div>
        <h2 className="font-head text-2xl font-bold text-slate-50">Prova la demo</h2>
        {info && <p className="text-sm text-slate-400 mt-1 mb-5" data-testid="demo-register-info">{info.studio_name} · la demo scade il {fmt(info.scadenza)}</p>}
        {err && <p className="text-sm text-red-500 mb-4" data-testid="demo-register-error">{err}</p>}
        {step === "email" && info && (
          <form onSubmit={register} className="space-y-4" data-testid="demo-register-form">
            <div><Label className="text-slate-300 text-sm">Nome</Label>
              <Input value={name} onChange={(e) => setName(e.target.value)} data-testid="demo-register-name" className="mt-1.5 h-11" /></div>
            <div><Label className="text-slate-300 text-sm">Email</Label>
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="demo-register-email" className="mt-1.5 h-11" /></div>
            <Button type="submit" disabled={busy} data-testid="demo-register-submit" className="w-full h-11 bg-amber-500 hover:bg-amber-600 text-[#0a0d14] font-semibold">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Ricevi codice di attivazione"}</Button>
          </form>
        )}
        {step === "otp" && (
          <form onSubmit={verify} className="space-y-4" data-testid="demo-otp-form">
            <p className="text-sm text-slate-400">Inserisci il codice a 6 cifre inviato a {email}.</p>
            <Input inputMode="numeric" maxLength={6} required value={code} onChange={(e) => setCode(e.target.value)} data-testid="demo-otp-input" className="h-11 tracking-[0.4em] text-center" />
            <Button type="submit" disabled={busy} data-testid="demo-otp-submit" className="w-full h-11 bg-amber-500 hover:bg-amber-600 text-[#0a0d14] font-semibold">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Attiva demo"}</Button>
          </form>
        )}
        {step === "done" && (
          <div className="space-y-4" data-testid="demo-register-done">
            <p className="text-sm text-slate-300">Registrazione completata. Accedi con la tua email <strong>{email}</strong> e la password <strong data-testid="demo-register-password">{finalPwd}</strong>.</p>
            <Link to="/login" data-testid="demo-go-login" className="block text-center rounded-md h-11 leading-[2.75rem] bg-amber-500 hover:bg-amber-600 text-[#0a0d14] font-semibold transition-colors">Vai al login</Link>
          </div>
        )}
      </div>
    </div>
  );
}
